import { Component, input } from '@angular/core';

@Component({
  selector: 'v-public-logo-header',
  templateUrl: './logo-header.component.html',
})
export class VLogoHeaderComponent {
  header = input.required<string>();
  subheader = input<string>();
}
